// extracted by mini-css-extract-plugin
export default {"season-switcher":"season-switcher_season-switcher__LGEVY","read-only":"season-switcher_read-only__m6IoO"};